import Clarity from '@microsoft/clarity';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import { App } from '@/app/App';
import { registerInventoryServiceWorker } from '@/shared/pwa/service-worker-registration';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://4238f1a2e3ce5559d858a3e9f7a7015e@o506301.ingest.us.sentry.io/4511738083606528',
    dataCollection: {},
  });
  Clarity.init('xmq1exck2z');
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element was not found.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

void registerInventoryServiceWorker();
